import Sudoku from "@components/ui/Sudoku"
import type { CompanyPageData } from "@site-types/public-page-data"
import CompanyDetailsTable from "./CompanyDetailsTable"
import CompanyStory from "./CompanyStory"
import CompanyTimeline from "./CompanyTimeline"

type CompanyDetailsProps = {
  data: CompanyPageData
}

export function CompanyDetails({ data }: CompanyDetailsProps) {
  return (
    <div className="relative">
      <CompanyStory />
      <CompanyTimeline historyItems={data.companyHistory} />
      <CompanyDetailsTable />
      <Sudoku />
    </div>
  )
}

export default CompanyDetails
